// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckBox_wrapper__2ev9L"};